import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";

const ZeusdbStatue = () => {
  // documentation

  // loose svms

  // install osirius ************************

  const [pythonIO, setpythonIO] = useState(true);
  const [rubyIO, setrubyIO] = useState(false);
  const [javascriptIO, setjavascriptIO] = useState(false);

  const firepythonIO = () => {
    //console.log(pythonCP);
    if (pythonIO === false) {
      setpythonIO(true);
      setjavascriptIO(false);
      setrubyIO(false);
    }
  };

  const firerubyIO = () => {
    if (rubyIO === false) {
      setrubyIO(true);
      setpythonIO(false);
      setjavascriptIO(false);
    }
  };

  const firejavascriptIO = () => {
    if (javascriptIO === false) {
      setjavascriptIO(true);
      setpythonIO(false);
      setrubyIO(false);
    }
  };

  // install osirius ************************

  // create platform ***********************************
  const [pythonCP, setpythonCP] = useState(true);
  const [rubyCP, setrubyCP] = useState(false);
  const [javascriptCP, setjavascriptCP] = useState();

  const firepythonCP = () => {
    if (pythonCP === false) {
      setrubyCP(false);
      setpythonCP(true);

      // setjavascriptGS(false);
    }
  };

  const firerubyCP = () => {
    if (rubyCP === false) {
      setpythonCP(false);
      setrubyCP(true);

      // setjavascriptGS(false);
    }
  };

  const firejavascriptCP = () => {
    if (javascriptCP === true) {
      setjavascriptCP(false);
    } else if (javascriptCP === false) {
      setjavascriptCP(true);
    }
  };

  // create platform ****************************

  // get structure *******************************

  const [pythonGS, setpythonGS] = useState(true);
  const [rubyGS, setrubyGS] = useState(false);
  const [javascriptGS, setjavascriptGS] = useState(false);

  const firepythonGS = () => {
    if (pythonGS === false) {
      setpythonGS(true);
      setrubyGS(false);
      setjavascriptGS(false);
    }
  };

  const firerubyGS = () => {
    if (rubyGS === false) {
      setrubyGS(true);
      setpythonGS(false);

      setjavascriptGS(false);
    }
  };

  const firejavascriptGS = () => {
    if (javascriptGS === false) {
      setjavascriptGS(true);
      setrubyGS(false);
      setpythonGS(false);
    }
  };

  // get structure *****************************

  // get all structures ***********************

  const [pythonGAS, setpythonGAS] = useState(true);
  const [rubyGAS, setrubyGAS] = useState(false);
  const [javascriptGAS, setjavascriptGAS] = useState();

  const firepythonGAS = () => {
    if (rubyGAS === true) {
      setrubyGAS(false);
    }

    if (javascriptGAS === true) {
      setjavascriptGAS(false);
    }
    if (pythonGAS === true) {
      setpythonGAS(false);
    } else if (pythonGAS === false) {
      setpythonGAS(true);
    }
  };

  const firerubyGAS = () => {
    // if (pythonGAS === true) {
    //   setpythonGAS(false);
    // }
    // if (javascriptGAS === true) {
    //   setjavascriptGAS(false);
    // }
    if (rubyGAS === true) {
      setrubyGAS(false);
    } else if (rubyGAS === false) {
      setrubyGAS(true);
    }
  };

  const firejavascriptGAS = () => {
    if (javascriptGAS === true) {
      setjavascriptGAS(false);
    } else if (javascriptGAS === false) {
      setjavascriptGAS(true);
    }
  };

  // get all structures **********************

  // create a structure *************************

  const [pythonCAS, setpythonCAS] = useState(true);
  const [rubyCAS, setrubyCAS] = useState(false);
  const [javascriptCAS, setjavascriptCAS] = useState();

  const firejavascriptCAS = () => {
    if (javascriptCAS === true) {
      setjavascriptCAS(false);
    } else if (javascriptCAS === false) {
      setjavascriptCAS(true);
    }
  };

  const firepythonCAS = () => {
    if (pythonCAS === false) {
      setrubyCAS(false);
      setpythonCAS(true);
      setjavascriptCAS(false);
    }
  };

  const firerubyCAS = () => {
    if (rubyCAS === false) {
      setrubyCAS(true);
      setpythonCAS(false);
      setjavascriptCAS(false);
    }
  };
  // create a structure *************************

  // update a structure *************************

  const [pythonUS, setpythonUS] = useState(true);
  const [rubyUS, setrubyUS] = useState(false);
  const [javascriptUS, setjavascriptUS] = useState();

  const firepythonUS = () => {
    if (pythonUS === false) {
      setpythonUS(true);
      setrubyUS(false);
      setjavascriptUS(false);
    }
  };

  const firerubyUS = () => {
    if (rubyUS === false) {
      setrubyUS(true);
      setpythonUS(false);

      setjavascriptUS(false);
    }
  };

  const firejavascriptUS = () => {
    if (javascriptUS === false) {
      setjavascriptUS(true);
      setrubyUS(false);
      setpythonUS(false);
    }
  };
  // update a structure *************************

  // delete a structure ****************************

  const [pythonDS, setpythonDS] = useState(true);
  const [rubyDS, setrubyDS] = useState(false);
  const [javascriptDS, setjavascriptDS] = useState();

  const firejavascriptDS = () => {
    if (javascriptDS === true) {
      setjavascriptDS(false);
    } else if (javascriptUS === false) {
      setjavascriptDS(true);
    }
  };

  const firepythonDS = () => {
    if (pythonDS === true) {
      setpythonDS(false);
    } else if (pythonUS === false) {
      setpythonDS(true);
    }
  };

  const firerubyDS = () => {
    if (rubyUS === true) {
      setrubyUS(false);
    } else if (rubyUS === false) {
      setrubyUS(true);
    }
  };
  // delete a structure ********************

  // useEffect(() => {
  //   firepythonGAS();
  // }, [firepythonGAS]);

  return (
    <div>
      <div className="statue-zeusdb-header">
        <Link className="statue-lantern" to="/login">
          Zeus{" "}
        </Link>{" "}
        Osirius
      </div>
      <div className="statue-lattice">
        <div className="statue-zeusdb-trim">
          <div className="hind">
            <div>
              Documents
              <div>
                <div>install</div>
                <div>download</div>
                <div>platforms</div>
                <div> structures v</div>
                <div>create</div>
                <div>findByID</div>
                <div>find</div>
                <hr />
                <div>.zrbh</div>

                {/* <div>post</div>
            <div>edit ( put push )</div>
            <div>delete</div>
            drystate */}
              </div>
            </div>
          </div>
        </div>

        <div className="statue-zeusdb-centerIsle">
          {/* 
          ##########################
          Download 
          ##########################
           */}
          <div className="statue-zeusdb-platefunctions">download</div>
          <div className="statue-zeusdb-plates">
            <div className="statue-zeusdb-plates-engravings">
              <div
                onClick={firepythonIO}
                className="statue-zeusdb-plates-engraving"
              >
                {" "}
                Python
              </div>
              <div
                onClick={firerubyIO}
                className="statue-zeusdb-plates-engraving"
              >
                Ruby{" "}
              </div>

              {/* <div
                onClick={firejavascriptIO}
                className="statue-zeusdb-plates-engraving"
              >
                Javascript
              </div> */}
              <div className="statue-zeusdb-plates-zeusyoomlion">Z</div>
            </div>
            <div className="statue-zeusdb-plates-code">
              {pythonIO && <div>$ python3 install osirius</div>}
              {rubyIO && <div>$ gem install osirius </div>}
              {javascriptIO && <div>$ npm install osirius </div>}
            </div>
          </div>

          {/* 
          ##########################
          Download 
          ##########################
           */}

          {/* 
          ##########################
          Activate
          ##########################
           */}

          <div className="statue-zeusdb-platefunctions">download</div>
          <div className="statue-zeusdb-plates">
            <div className="statue-zeusdb-plates-engravings">
              <div className="statue-zeusdb-plates-engraving"> Python</div>
              {/* <div
                onClick={firerubyIO}
                className="statue-zeusdb-plates-engraving"
              >
                Ruby{" "}
              </div> */}

              {/* <div
                onClick={firejavascriptIO}
                className="statue-zeusdb-plates-engraving"
              >
                Javascript
              </div> */}
              <div className="statue-zeusdb-plates-zeusyoomlion">Z</div>
            </div>
            <div className="statue-zeusdb-plates-code">
              <div>
                <div>
                  <code> 1 </code>
                </div>
                <div>
                  <code> 2 </code>
                </div>
                <div>
                  <code> 3 </code> # initialize
                  {/* {` aws `} */}
                </div>
                <div>
                  <code> 4 </code>
                </div>
                <div>
                  <code> 5 </code> {`zeusserver = osirius.activate({creds})`}
                  {/* {`zeusserver = osirius.activate({"dataZone":"aws","AWS_ACCESS_KEY_ID": f'{AWS_ACCESS_KEY_ID}', "AWS_SECRET_ACCESS_KEY" : f'{AWS_SECRET_ACCESS_KEY}', "AWS_S3_BUCKET_NAME" :f'{AWS_S3_BUCKET_NAME}' })`} */}
                </div>
                <div>
                  <code> 6 </code>
                </div>
                <div>
                  <code> 7 </code>
                  {/* {` azure `} */}
                </div>
                <div>
                  <code> 8 </code>
                  {/* {`zeusserver = osirius.activate({"dataZone":"azure","AZURE_CONNECTION_STRING": f'{AZURE_CONNECTION_STRING}', "AZURE_KEY" : f'{AZURE_KEY}', "AZURE_CONTAINER_NAME" :f'{AZURE_CONTAINER_NAME}' , "AZURE_STORAGE_ACCOUNT_NAME" : f'{AZURE_STORAGE_ACCOUNT_NAME}' }) `} */}
                </div>
                <div>
                  <code> 9 </code>
                  {/* {`zeusserver = osirius.activate({creds})`} */}
                </div>
                <div>
                  <code> 10 </code>
                </div>
                <div>
                  <code> 11 </code>
                  {/* {` google cloud `} */}
                </div>
                <div>
                  <code> 12 </code>
                </div>
                <div>
                  <code> 13 </code>
                  {/* {`zeusserver = osirius.activate({creds})`} */}
                  {/* {` zeusserver = osirius.activate({"dataZone":'googlec' , "credentials_file":data }) `} */}
                </div>
                <div>
                  <code> 14 </code>
                </div>
              </div>

              {rubyIO && <div>$ gem install osirius </div>}
              {javascriptIO && <div>$ npm install osirius </div>}
            </div>
          </div>

          {/* 
          ##########################
          Activate 
          ##########################
           */}

          {/* <div>start server</div>
        <div> server </div>
        <div>simple requests</div> */}

          <div className="statue-zeusdb-leaderplateplatforms">
            <div className="statue-zeusdb-platefunctions"> 🌠 Platforms 🌠</div>
            <div>
              <div className="statue-zeusdb-platetitles">create platform</div>

              <div className="statue-zeusdb-plates">
                <div>
                  {/* <div>go </div> */}
                  <div className="statue-zeusdb-plates-engravings">
                    <div
                      className="statue-zeusdb-plates-engraving"
                      onClick={firepythonCP}
                    >
                      {" "}
                      Python{" "}
                    </div>
                    {/* <div
                      className="statue-zeusdb-plates-engraving"
                      onClick={firerubyCP}
                    >
                      Ruby{" "}
                    </div> */}

                    {/* <div
                    className="statue-zeusdb-plates-engraving"
                    onClick={firejavascriptCP}
                  >
                    Javascript
                  </div> */}
                    <div className="statue-zeusdb-plates-zeusyoomlion">Z</div>
                  </div>
                </div>
                <div className="statue-zeusdb-plates-code">
                  {pythonCP && (
                    <div>
                      <div>
                        <code> 1 </code>
                      </div>

                      <div>
                        <code> 2 </code> # initialize platform
                      </div>

                      <div>
                        <code> 3 </code>
                      </div>
                      <div>
                        {" "}
                        <code> 4 </code> oy =
                        Osirius.makePlatform("Dios-Favorite-Snacks")
                      </div>
                      <div>
                        {" "}
                        <code> 5 </code>
                      </div>
                      <div>
                        {" "}
                        <code> 6 </code>
                      </div>
                    </div>
                  )}
                  {rubyCP && (
                    <div>
                      <div>
                        <code> 1 </code>
                      </div>

                      <div>
                        <code> 2 </code> # initialize platform
                      </div>

                      <div>
                        <code> 3 </code>
                      </div>
                      <div>
                        {" "}
                        <code> 4 </code> oy =
                        Osirius::Bolt.new("Dios-Favorite-Snacks")
                      </div>
                      <div>
                        {" "}
                        <code> 5 </code>
                      </div>
                      <div>
                        {" "}
                        <code> 6 </code>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* ###### Create ###### */}

          <div>
            <div className="statue-zeusdb-platefunctions"></div>
            <div>
              <div className="statue-zeusdb-platetitles">create structure</div>

              <div className="statue-zeusdb-plates">
                <div>
                  {/* <div>go </div> */}

                  <div className="statue-zeusdb-plates-engravings">
                    <div
                      className="statue-zeusdb-plates-engraving"
                      onClick={firepythonCAS}
                    >
                      {" "}
                      Python{" "}
                    </div>{" "}
                    {/* <div
                      className="statue-zeusdb-plates-engraving"
                      onClick={firerubyCAS}
                    >
                      Ruby{" "}
                    </div>{" "} */}
                    {/* <div
                    className="statue-zeusdb-plates-engraving"
                    onClick={firejavascriptGS}
                  >
                    Javascript
                  </div> */}
                    <div className="statue-zeusdb-plates-zeusyoomlion">Z</div>
                  </div>
                </div>
                <div className="statue-zeusdb-plates-code">
                  {pythonCAS && (
                    <div>
                      <div>
                        {" "}
                        <code> 1 </code>
                      </div>
                      <div>
                        {" "}
                        <code> 2 </code> # create a structure
                      </div>
                      <div>
                        {" "}
                        <code> 3 </code>
                        <br />
                        <code> 4 </code> oy =
                        <br />
                        <code> 5 </code> {`{ " brunch " : " blueberries ",`}
                        <br />
                        <code> 6 </code> {`   " dinner " : " pizza "}, `}
                        <br />
                        <code> 7</code> {`  { `}
                        <br />
                        <code> 8 </code> {` " snacks " : [ `}
                        <br />
                        <code> 9 </code>{" "}
                        {`  {" yummies " : " bacon , egg , and cheese "}, `}
                        <br /> <code> 10 </code>{" "}
                        {`  {" yummies " : " crab cakes "} `}
                        <br /> <code> 11 </code> {` } ] `}
                        <br />
                        <code> 12 </code>
                      </div>
                      <div>
                        {" "}
                        <code> 13 </code> zeusserver.create(oy){" "}
                      </div>
                      <div>
                        {" "}
                        <code> 14 </code>
                      </div>
                    </div>
                  )}
                  {rubyCAS && (
                    <div>
                      <div>
                        {" "}
                        <code> 1 </code>
                      </div>
                      <div>
                        {" "}
                        <code> 2 </code> # find structure
                      </div>
                      <div>
                        {" "}
                        <code> 3 </code>
                      </div>
                      <div>
                        {" "}
                        <code> 4 </code>{" "}
                        zeusserver.findByID("5euz37c2-i3g8-3471-t2")
                      </div>
                      <div>
                        {" "}
                        <code> 5 </code>
                      </div>
                      <div>
                        {" "}
                        <code> 6 </code>
                      </div>
                    </div>
                  )}
                  {javascriptGS && (
                    <div>
                      <div>
                        {" "}
                        <code> 1 </code> python * check *{" "}
                      </div>
                      <div>
                        {" "}
                        <code> 2 </code>
                      </div>
                      <div>
                        {" "}
                        <code> 3 </code>
                      </div>
                      <div>
                        {" "}
                        <code> 4 </code>
                      </div>
                      <div>
                        {" "}
                        <code> 5 </code>
                      </div>
                      <div>
                        {" "}
                        <code> 6 </code>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* ##### Create ##### */}

          <div>
            <div className="statue-zeusdb-platefunctions"></div>
            <div>
              <div className="statue-zeusdb-platetitles">
                get structure by id
              </div>

              <div className="statue-zeusdb-plates">
                <div>
                  {/* <div>go </div> */}

                  <div className="statue-zeusdb-plates-engravings">
                    <div
                      className="statue-zeusdb-plates-engraving"
                      onClick={firepythonGS}
                    >
                      {" "}
                      Python{" "}
                    </div>{" "}
                    {/* <div
                      className="statue-zeusdb-plates-engraving"
                      onClick={firerubyGS}
                    >
                      Ruby{" "}
                    </div>{" "} */}
                    {/* <div
                    className="statue-zeusdb-plates-engraving"
                    onClick={firejavascriptGS}
                  >
                    Javascript
                  </div> */}
                    <div className="statue-zeusdb-plates-zeusyoomlion">Z</div>
                  </div>
                </div>
                <div className="statue-zeusdb-plates-code">
                  {pythonGS && (
                    <div>
                      <div>
                        {" "}
                        <code> 1 </code>
                      </div>
                      <div>
                        {" "}
                        <code> 2 </code> # find structure
                      </div>
                      <div>
                        {" "}
                        <code> 3 </code>
                      </div>
                      <div>
                        {" "}
                        <code>
                          {" "}
                          4{" "}
                        </code> zeusserver.findByID("h3ll0-zeusdb-1D"){" "}
                      </div>
                      <div>
                        {" "}
                        <code> 5 </code>
                      </div>
                      <div>
                        {" "}
                        <code> 6 </code>
                      </div>
                    </div>
                  )}
                  {rubyGS && (
                    <div>
                      <div>
                        {" "}
                        <code> 1 </code>
                      </div>
                      <div>
                        {" "}
                        <code> 2 </code> # find structure
                      </div>
                      <div>
                        {" "}
                        <code> 3 </code>
                      </div>
                      <div>
                        {" "}
                        <code> 4 </code> oy.findByID("h3ll0zeusdb1D")
                      </div>
                      <div>
                        {" "}
                        <code> 5 </code>
                      </div>
                      <div>
                        {" "}
                        <code> 6 </code>
                      </div>
                    </div>
                  )}
                  {javascriptGS && (
                    <div>
                      <div>
                        {" "}
                        <code> 1 </code> python * check *{" "}
                      </div>
                      <div>
                        {" "}
                        <code> 2 </code>
                      </div>
                      <div>
                        {" "}
                        <code> 3 </code>
                      </div>
                      <div>
                        {" "}
                        <code> 4 </code>
                      </div>
                      <div>
                        {" "}
                        <code> 5 </code>
                      </div>
                      <div>
                        {" "}
                        <code> 6 </code>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* 
          <div>
            <div className="statue-zeusdb-platetitles">get all structures</div>
            <div className="statue-zeusdb-plates">
              <div className="statue-zeusdb-plates-engravings">
                <div
                  className="statue-zeusdb-plates-engraving"
                  onClick={firepythonGAS}
                >
                  Python
                </div>
                <div
                  className="statue-zeusdb-plates-engraving"
                  onClick={firerubyGAS}
                >
                  Ruby
                </div>
                <div
                  className="statue-zeusdb-plates-engraving"
                  onClick={firejavascriptGAS}
                >
                  Javascript
                </div>
                <div className="statue-zeusdb-plates-zeusyoomlion">Z</div>
              </div>

              <div className="statue-zeusdb-plates-code">
                {rubyGAS && (
                  <div>
                    <div>
                      <code>1</code>
                      require osirius dionysus = osirius.findall
                    </div>
                    <div>
                      <code> 2 </code>
                    </div>
                    <div>
                      <code> 3 </code>
                    </div>
                    <div>
                      <code> 4 </code>
                    </div>
                    <div>
                      <code> 5 </code>
                    </div>
                  </div>
                )}
                {pythonGAS && (
                  <div>
                    <div>
                      <code> 1 </code>
                      import osirius
                    </div>
                    <div>
                      <code> 2 </code>
                      dionysus = osirius.findAll
                    </div>
                    <div>
                      <code> 3 </code>
                    </div>
                    <div>
                      <code> 4 </code>
                    </div>
                    <div>
                      <code> 5 </code>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div> */}
          </div>
          {/* <div>
          <div className="statue-zeusdb-platefunctions">post</div>
          <div>
            <div>
              <div className="statue-zeusdb-platetitles"> create Structure</div>

              <div className="statue-zeusdb-plates">
                <div className="statue-zeusdb-plates-engravings">
                  <div className="statue-zeusdb-plates-engraving"> Python</div>
                  <div className="statue-zeusdb-plates-engraving">Ruby</div>
                  <div className="statue-zeusdb-plates-engraving">
                    Javascript
                  </div>
                  <div className="statue-zeusdb-plates-zeusyoomlion">Z</div>
                </div>
                <div className="statue-zeusdb-plates-code">
                  <div>go * check * </div>
                  <div>ruby * check * </div>
                  <div>python * check * </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
          {/* <div>
          <div className="statue-zeusdb-platefunctions">update</div>
          <div>
            <div className="statue-zeusdb-platetitles">
              update structure by id
            </div>
            <div className="statue-zeusdb-plates">
              <div className="statue-zeusdb-plates-engravings">
               
                <div className="statue-zeusdb-plates-engraving">Python</div>
                <div className="statue-zeusdb-plates-engraving">Ruby</div>

                <div className="statue-zeusdb-plates-engraving">Javascript</div>
                <div className="statue-zeusdb-plates-zeusyoomlion">Z</div>
              </div>
              <div className="statue-zeusdb-plates-code">
                <div>python * check *</div> <div>ruby * finish *</div>{" "}
                <div>js *</div>{" "}
              </div>
            </div>
          </div>
        </div> */}
          {/* 
        <div>
          <div className="statue-zeusdb-platefunctions">delete</div>
          <div>
            <div className="statue-zeusdb-platetitles">
              delete structure by id
            </div>
            <div className="statue-zeusdb-plates">
              <div>
               
                <div c className="statue-zeusdb-plates-engraving">
                  Python
                </div>{" "}
                <div className="statue-zeusdb-plates-engraving"> Ruby</div>{" "}
                <div className="statue-zeusdb-plates-engraving">Javascript</div>
              </div>
              <div className="statue-zeusdb-plates-code">
                <div>python * finish *</div> <div>ruby * finish *</div>{" "}
                <div>javascript * check*</div>
              </div>
            </div>
          </div>
        </div> */}

          {/* <div>developer tricks ( sessions or transactions ) </div> */}
        </div>
      </div>
    </div>
  );
};

export default ZeusdbStatue;
